export default function GreenManGamingLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 135.6 135.7"
      className={className}
      fill="currentColor"
    >
      <g transform="translate(10, 10) scale(0.85)">
        <path
          fill="#00e205"
          d="M108.4 93.8a47.14 47.14 0 0 1-31 14.5V93.8h31zm-50.1 14.5c-12.2-.8-23.1-6.2-31.1-14.5h31.1v14.5zM135.6 0H67.9C30.4 0 0 30.3 0 67.8s30.4 67.9 67.9 67.9c35.9 0 65.2-27.8 67.7-63.1V0z"
        />
      </g>
    </svg>
  );
}
